import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/artwork/$artworkId/modal")({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/artwork/$artworkId/modal"!</div>;
}
